module.exports = __webpack_public_path__ + "img/block_3.69f0b522.png";